export default __webpack_public_path__ + "static/media/find.ee412899.svg";